import * as z from "zod";

export const triggerHubspotMirrorSyncInputSchema = z.object({
  /**
   * `hourly` = delta sync (last 24h). `nightly` = full pipeline refresh.
   * Use `nightly` for initial backfill or when the bookmark is stale.
   */
  mode: z.enum(["hourly", "nightly"]).default("nightly"),
});
export type TriggerHubspotMirrorSyncInput = z.infer<
  typeof triggerHubspotMirrorSyncInputSchema
>;

export const triggerHubspotMirrorSyncOutputSchema = z.object({
  success: z.boolean(),
  workflowId: z.string().nullable(),
  error: z.string().nullable(),
});
export type TriggerHubspotMirrorSyncOutput = z.infer<
  typeof triggerHubspotMirrorSyncOutputSchema
>;

export const triggerHubspotMirrorSync = {
  name: "triggerHubspotMirrorSync" as const,
  input: triggerHubspotMirrorSyncInputSchema,
  output: triggerHubspotMirrorSyncOutputSchema,
};
